import { computed, onMounted } from "vue";
import { useOrganizationStore } from "../stores";
export function useOrganizations(options = {}) {
    const store = useOrganizationStore();
    async function load(forceRefresh = false) {
        try {
            await store.fetchAll(forceRefresh);
        }
        catch (err) {
            options.onError?.(err);
        }
    }
    if (options.autoLoad !== false) {
        onMounted(() => load());
    }
    return {
        organizations: computed(() => store.organizations),
        activeOrganizations: computed(() => store.activeOrganizations),
        members: computed(() => store.members),
        bankAccounts: computed(() => store.bankAccounts),
        brandThemes: computed(() => store.brandThemes),
        fonts: computed(() => store.fonts),
        isLoading: computed(() => store.isLoading),
        isSaving: computed(() => store.isSaving),
        isLoadingFonts: computed(() => store.isLoadingFonts),
        error: computed(() => store.error),
        fontsError: computed(() => store.fontsError),
        load,
        createOrganization: store.createOrganization,
        updateOrganization: store.updateOrganization,
        loadBankAccounts: store.fetchBankAccounts,
        addBankAccount: store.addBankAccount,
        updateBankAccount: store.updateBankAccount,
        removeBankAccount: store.removeBankAccount,
        loadBrandTheme: store.fetchBrandTheme,
        updateBrandTheme: store.updateBrandTheme,
        loadFonts: store.fetchGoogleFonts,
        loadMembers: store.fetchMembers,
        addMember: store.addMember,
        updateMember: store.updateMember,
        removeMember: store.removeMember,
    };
}
